import McDataDisplay from './McDataDisplay';

export default McDataDisplay;
